module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-75.1f33915a.svg";